import React, { useEffect, useState } from 'react';
import { Calendar as CalendarComponent } from 'components';
import {
  Container,
  AppBar,
  Toolbar,
  Button,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import backV1 from 'assets/images/backV1.svg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useUserSearchContext } from 'context/UserSearchContext';

export const Calendar: React.FC = () => {
  const { bookingSearchData, setBookingSearchData } = useUserSearchContext();
  const currentYear: number = new Date().getFullYear();
  const { dateTypeParams } = useParams();
  const selectedYear = new Date(
    dateTypeParams === 'pickup-date'
      ? bookingSearchData.OutDetails.Date
      : bookingSearchData.InDetails.Date
  ).getFullYear();

  const [year, setYear] = useState<number>(selectedYear);
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };
  const [locationType, setLocationType] = useState<string | null>(null);
  useEffect(() => {
    if (dateTypeParams !== undefined) {
      const locationTitle =
        dateTypeParams === 'pickup-date' ? 'Pickup date' : 'Return Date';
      setLocationType(locationTitle);
    }
  }, []);

  const changeYear = (action: 'next' | 'back') => {
    if (action === 'next') {
      setYear(year + 1);
      return;
    }
    setYear(year - 1);
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Sticky AppBar */}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: '#043d60',
          backdropFilter: 'blur(8px)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Box width={'90%'} margin={'auto'}>
          <Toolbar>
            <Button onClick={handleBackClick} sx={{ mr: 2 }}>
              <Box
                component="img"
                src={backV1}
                alt="Back button"
                sx={{ width: 100 }}
              />
            </Button>

            <Typography
              className="navbarTitle"
              color="primary"
              component="p"
              sx={{
                fontWeight: 500,
                '@media (orientation: portrait)': {
                  textAlign: 'start',
                  marginLeft: '50px',
                },
              }}
            >
              {`CHOOSE YOUR `}
              <Box
                component="span"
                sx={{ textDecoration: 'underline', fontWeight: 600 }}
              >
                {locationType?.toUpperCase()}
              </Box>
            </Typography>
          </Toolbar>

          {/* Divider below AppBar */}
          <Divider sx={{ backgroundColor: 'lightgray', height: '1px' }} />

          <Toolbar sx={{ justifyContent: 'end' }}>
            <Box sx={{ display: 'flex' }}>
              <Button
                onClick={() => changeYear('back')}
                disabled={year === currentYear}
                sx={{
                  '&.Mui-disabled': {
                    color: '#fff', // text when disabled
                  },
                }}
              >
                <ArrowBackIosNewIcon />
              </Button>
              <Typography variant="h2">{year}</Typography>
              <Button onClick={() => changeYear('next')}>
                <ArrowForwardIosIcon />
              </Button>
            </Box>
          </Toolbar>
        </Box>
      </AppBar>

      {/* Main content inside Container */}
      <CalendarComponent year={year} currentYear={currentYear} />
    </Box>
  );
};
